import {useListView} from '../../core/ListViewProvider'
import {GroupDiscountsListToolbar} from './GroupDiscountListToolbar'
import {GroupDiscountsListGrouping} from './GroupDiscountsListGrouping'
import {GroupDiscountsListSearchComponent} from './GroupDiscountsListSearchComponent'

const GroupDiscountsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <GroupDiscountsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <GroupDiscountsListGrouping /> : <GroupDiscountsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {GroupDiscountsListHeader}
